module.exports = __webpack_public_path__ + "img/img9.8649f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img9.png
// module id = 218
// module chunks = 0